// Ingestion Jobs Actions
const action = "INGESTION_JOBS";

// List jobs actions
export const LIST_REQUEST = action + '_LIST_REQUEST';
export const LIST_SUCCESS = action + '_LIST_SUCCESS';
export const LIST_FAILURE = action + '_LIST_FAILURE';

// Create job actions
export const CREATE_REQUEST = action + '_CREATE_REQUEST';
export const CREATE_SUCCESS = action + '_CREATE_SUCCESS';
export const CREATE_FAILURE = action + '_CREATE_FAILURE';

// Update job actions
export const UPDATE_REQUEST = action + '_UPDATE_REQUEST';
export const UPDATE_SUCCESS = action + '_UPDATE_SUCCESS';
export const UPDATE_FAILURE = action + '_UPDATE_FAILURE';

// Delete job actions
export const DELETE_REQUEST = action + '_DELETE_REQUEST';
export const DELETE_SUCCESS = action + '_DELETE_SUCCESS';
export const DELETE_FAILURE = action + '_DELETE_FAILURE';

// Trigger job actions
export const TRIGGER_REQUEST = action + '_TRIGGER_REQUEST';
export const TRIGGER_SUCCESS = action + '_TRIGGER_SUCCESS';
export const TRIGGER_FAILURE = action + '_TRIGGER_FAILURE';

// Preview schedule actions
export const PREVIEW_SCHEDULE_REQUEST = action + '_PREVIEW_SCHEDULE_REQUEST';
export const PREVIEW_SCHEDULE_SUCCESS = action + '_PREVIEW_SCHEDULE_SUCCESS';
export const PREVIEW_SCHEDULE_FAILURE = action + '_PREVIEW_SCHEDULE_FAILURE';

// Clear state action
export const CLEAR = action + '_CLEAR';

// Action creators
export const listJobs = (payload = {}) => ({
  type: LIST_REQUEST,
  payload
});

export const listJobsSuccess = (response) => ({
  type: LIST_SUCCESS,
  payload: response
});

export const listJobsFailure = (error) => ({
  type: LIST_FAILURE,
  payload: error
});

export const createJob = (payload) => ({
  type: CREATE_REQUEST,
  payload
});

export const createJobSuccess = (response) => ({
  type: CREATE_SUCCESS,
  payload: response
});

export const createJobFailure = (error) => ({
  type: CREATE_FAILURE,
  payload: error
});

export const updateJob = (jobId, payload) => ({
  type: UPDATE_REQUEST,
  payload: { jobId, ...payload }
});

export const updateJobSuccess = (response) => ({
  type: UPDATE_SUCCESS,
  payload: response
});

export const updateJobFailure = (error) => ({
  type: UPDATE_FAILURE,
  payload: error
});

export const deleteJob = (jobId) => ({
  type: DELETE_REQUEST,
  payload: { jobId }
});

export const deleteJobSuccess = (response) => ({
  type: DELETE_SUCCESS,
  payload: response
});

export const deleteJobFailure = (error) => ({
  type: DELETE_FAILURE,
  payload: error
});

export const triggerJob = (jobId) => ({
  type: TRIGGER_REQUEST,
  payload: { jobId }
});

export const triggerJobSuccess = (response) => ({
  type: TRIGGER_SUCCESS,
  payload: response
});

export const triggerJobFailure = (error) => ({
  type: TRIGGER_FAILURE,
  payload: error
});

export const previewSchedule = (jobId, n = 5) => ({
  type: PREVIEW_SCHEDULE_REQUEST,
  payload: { jobId, n }
});

export const previewScheduleSuccess = (response) => ({
  type: PREVIEW_SCHEDULE_SUCCESS,
  payload: response
});

export const previewScheduleFailure = (error) => ({
  type: PREVIEW_SCHEDULE_FAILURE,
  payload: error
});

export const clearState = () => ({
  type: CLEAR
});
